import { artStyles } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ArtStylesSection() {
  return (
    <section id="styles" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="画风图鉴"
          title="六种常见画风，先对眼缘再读故事"
          desc="同一题材下，画风差异带来的观感可能天差地别。这里把岳母题材常见的插画与漫画风格拆成六个流派，附上关键特征，方便你按审美先行筛选。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {artStyles.map((style) => (
            <article
              key={style.id}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 flex flex-col"
            >
              <div className="relative w-full h-64 md:h-72 overflow-hidden">
                <img
                  src={style.img}
                  alt={`${style.name}画风示例：${style.desc}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-medium">
                  <i className="ri-brush-line"></i>
                  {style.traits.length} 个特征
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {style.name}
                </h3>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {style.traits.map((t) => (
                    <span
                      key={t}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">
                  {style.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}